// src/apps/Pos/Orders/modals/AddPoolModal.tsx

// src/apps/Pos/Orders/modals/AddPoolModal.tsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import Modal from '../../../../components/Modal';
import orders from '../../../../services/api/orders/orders';

interface Props {
  open: boolean;
  onClose: () => void;
  activeDelivererId?: string | null;
  orderId: string;
  statusId?: number;
  getGroupedOrders: (
    dayId: string,
    isActive: boolean,
    isCompleted: boolean,
    isCanceled: boolean,
    page: number,
    statusIds: number[] | null,
  ) => Promise<void>;
  selectActive: number;
  page: number;
  statusIds: number[];
  meProfile: any;
  setAddCourierModal?: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
}

function AddPoolModal({
  open,
  onClose,
  activeDelivererId,
  setAddCourierModal,
  orderId,
  statusId,
  getGroupedOrders,
  selectActive,
  page,
  statusIds,
  meProfile,
}: Props) {
  const { t } = useTranslation('orders');

  const { enqueueSnackbar } = useSnackbar();

  const handlePositiveClick = async () => {
    try {
      await orders.useLastMileDeliveryService(orderId);
      onClose();
      setAddCourierModal && setAddCourierModal(false);
      if (meProfile?.activeBranch?.day_id) {
        await getGroupedOrders(
          meProfile.activeBranch.day_id,
          selectActive === 0,
          selectActive === 1,
          selectActive === 2,
          page,
          statusIds,
        );
      }
    } catch (error) {
      if (error instanceof Error) {
        enqueueSnackbar(error.message, {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An unknown error occurred', {
          variant: 'error',
        });
      }
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Teslimat Havuzu"
      positiveAction="Havuza Gönder"
      onPositiveClick={handlePositiveClick}
      negativeAction="Kapat"
      onNegativeClick={onClose}
    >
      <div>
        Teslimat Havuzu sayesinde çevrenizdeki uygun teslimat sağlayıcıları ve
        kuryeler ile siparişinizi güvenle ulaştırabilirsiniz.
      </div>
    </Modal>
  );
}

export default AddPoolModal;
